import styled from "styled-components";

interface IProps {
  marginLeft?: string;
}

export const SummaryContainer = styled.div`
  padding-top: 25px;
  display: flex;
  margin-left: ${(props: IProps) =>
    props.marginLeft ? props.marginLeft : "0px"};
  div {
    margin-right: 15px;
  }
`;
